.description {
  font-size: 12px;
  font-weight: 300;
  line-height: 1.55;
  text-align: center;
}

@container press-release-root (min-width: 400px) {
  .pressReleaseRoot > span {
    display: inline-block;
  }
}

@container press-release-root (min-width: 1024px) {
  .pressReleaseRoot {
    font-size: 13px;

    > span {
      display: block;
    }
  }
}

@media screen and (width >= 400px) {
  .screen > span {
    display: inline-block;
  }
}

@media screen and (width >= 1024px) {
  .screen {
    font-size: 13px;

    > span {
      display: block;
    }
  }
}
